module.exports = __webpack_public_path__ + "static/media/mini_quadcopter1.4a700179.jpg";